import config from 'config'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styles from './styles.module.scss'
import Spinner from 'srcReact/components/common2/Spinner'
import MainContent from '../MainContent'
import MemberSearchTextBox from '../MemberSearchTextBox'

const ReviewHistory = ({ searchText, setSearchText }) => {
  const { t } = useTranslation()

  const {
    moderationReport: { loading, moderation_data }
  } = useSelector((state) => state)

  return (
    <div className={styles.reviewHistoryWrapper}>
      <div className={styles.reviewHistoryTabs}>
        <MemberSearchTextBox searchText={searchText} setSearchText={setSearchText} />
      </div>
      {loading ? (
        <Spinner />
      ) : (
        moderation_data.posts &&
        moderation_data.posts.map((post, idx) => (
          <MainContent key={idx} postId={post.object_id} type='history' post={post} />
        ))
      )}
    </div>
  )
}

export default ReviewHistory
